import { FormBase } from 'core/components';
import validatorjs from 'validatorjs';

export default class CustomLabelForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				'carrierType',
				'useCustomReturnAddress',
				'returnName',
				'returnPhone',
				'sellerName',
				'sellerPhone',
				'attentionName',
				'returnAddress',
				'returnCity',
				'returnZip',
				'returnState',
				'customFieldInputs',
				'customFieldInputs[].id',
				'customFieldInputs[].value',
				'customFieldInputs[].fieldNumber',
				'customFieldInputs[].lastIndex',
				'customFieldInputs[].displayDropdown',
				'customFieldInputs[].previousValue',
				'customFieldInputs[].customFieldInputVariables',
				'customFieldInputs[].customFieldInputVariables[].id',
				'customFieldInputs[].customFieldInputVariables[].customFieldVariableId',
				'customFieldInputs[].customFieldInputVariables[].customFieldInputId',
				'customFieldInputs[].customFieldInputVariables[].position',
			],
			labels: {
				carrierType: 'Preview',
				useCustomReturnAddress: '',
				returnName: 'CUSTOMLABEL.RETURNNAME',
				returnPhone: 'CUSTOMLABEL.RETURNPHONE',
				sellerName: 'CUSTOMLABEL.SELLERNAME',
				sellerPhone: 'CUSTOMLABEL.SELLERPHONE',
				returnAddress: 'CUSTOMLABEL.RETURNADDRESS',
				returnCity: 'CUSTOMLABEL.RETURNCITY',
				returnZip: 'CUSTOMLABEL.RETURNZIP',
				returnState: 'CUSTOMLABEL.RETURNSTATE',
				attentionName: 'CUSTOMLABEL.ATTENTIONNAME',
			},
			rules: {
				sellerName: 'required',
				sellerPhone: 'required',
			},
			initials: {
				useCustomReturnAddress: false,
			},
		};
	}
	options() {
		return {
			validateOnBlur: false,
			showErrorsOnReset: false,
			validateOnChange: true,
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/CustomLabelForm.js